import ScorecardItemImportStep2 from 'scoreboard/scorecards/edit/import/scorecard-item-import-step2'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

const InitiativeItemImportStep2 = ScorecardItemImportStep2.extend({

	validMappingOptions: function () {
		return ALL_MAPPING_OPTIONS
	},

	getColumnMappings: function () {
		let columnMappings = {}
		columnMappings.initiativeColumns = []
		columnMappings.taskColumns = []
		columnMappings.milestoneColumns = []
		let headerVals = this.sourceDataPanel.porter.val()

		_.each(headerVals, (typePackages, columnName) => {
			if (columnName === 'available') {
				return
			}
			// only 1 package allowed in each column
			let typePackage = typePackages[0]
			if (typePackage) {
				let colType = typePackage.id
				if (colType === 'initiative') {
					columnMappings.initiativeColumns.push(columnName)
				} else if (colType === 'task') {
					columnMappings.taskColumns.push(columnName)
				} else if (colType === 'milestone') {
					columnMappings.milestoneColumns.push(columnName)
				} else {
					columnMappings[colType + 'Column'] = columnName
				}
			}
		})
		return columnMappings
	},

	context: function () {
		return {
			title: i18n.get('admin.import.initiativeItemImport')
		}
	},

	url: function () {
		return 'api/imports/initiative-items'
	},

	countMessageKey: function() {
		return 'admin.import.initiativeItem'
	}
})

const ALL_MAPPING_OPTIONS = [
	{id: 'initiative', label: 'initiatives.type.initiative', multiple: true},
	{id: 'task', label: 'initiatives.type.task', multiple: true},
	{id: 'milestone', label: 'initiatives.type.milestone', multiple: true},
	{id: 'description', label: 'common.description', multiple: false},
	{id: 'start', label: 'initiatives.startDate', multiple: false},
	{id: 'due', label: 'initiatives.dueDate', multiple: false},
	{id: 'budget', label: 'initiatives.budget', multiple: false},
	{id: 'goal', label: 'initiatives.goalFunction', multiple: false},
	{id: 'tags', label: 'common.tags', multiple: false}
]

export default InitiativeItemImportStep2

InitiativeItemImportStep2.__filename__ = 'initiatives/import/initiative-item-import-step2.js'
